import client from "./apiConfig";
import { PAGE_DEFAULT, LIMIT } from "../constants";
import { SmsCashflowSearchParams } from "../dataType/smsCashflow";

export default {
	getSmsCashflow(page = PAGE_DEFAULT, size = LIMIT, params: SmsCashflowSearchParams) {
		const url = `/sms/cashflow?page=${page}&size=${size}`;
		return client.post(url, params);
	}
}